import React from 'react';
import { truncateText, visuallyHidden } from 'lib/core';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const StyledButtonText = styled.span`
  ${truncateText}
  color: inherit;
  display: inline-block;
  pointer-events: none;
  z-index: ${({ theme }) => theme.zIndex.buttonContent.value};

  ${({ $isHidden }) =>
    $isHidden &&
    css`
      ${visuallyHidden}

      && {
        position: absolute;
      }
    `}
`;

const ButtonText = ({ isHidden = false, ...props }) => <StyledButtonText $isHidden={isHidden} {...props} />;

ButtonText.propTypes = {
  /** If true, visually hides text */
  isHidden: PropTypes.bool,
};

export { ButtonText };
